import React from 'react';
import env from './env';

export default class Page extends React.Component {

    constructor(args) {
        super(args);
        if (this.componentDidMount) {
            let child_mount_cb = this.componentDidMount;
            this.componentDidMount = () => {
                this._componentDidMount();
                child_mount_cb.call(this);
            }
        } else {
            this.componentDidMount = this._componentDidMount;
        }
    }

    _componentDidMount() {
        if (!this.props.match || !this.props.match.isExact) {
            return;
        }
        env.dispatch({
            type: 'app/page_load',
            payload: {
                path: this.props.match.path,  
            }
        });
        this.scroll_top();
    }

    scroll_top() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

}




// WEBPACK FOOTER //
// ./src/lib/page.js